/**
 * Centralized configuration from environment variables.
 * Required: REACT_APP_BACKEND_URL (e.g. http://localhost:8000)
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || import.meta.env?.REACT_APP_BACKEND_URL || "http://localhost:8000";

export const API = `${BACKEND_URL}/api`;
export const WS_URL = BACKEND_URL.replace("https://", "wss://").replace("http://", "ws://");

// For components that need the raw URL
export { BACKEND_URL };
